import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@flixbus/honeycomb-react';
import { Icon, IconArrowLeft } from '@flixbus/honeycomb-icons-react';

import styles from './upload-csv-submit.module.scss';

type UploadCSVSubmitProps = {
  canConfirm: boolean;
  onConfirm: () => void;
};

const UploadCSVSubmit: React.FC<UploadCSVSubmitProps> = ({ canConfirm, onConfirm }) => {
  return (
    <div className={styles.container}>
      <Button Elem='a' appearance='link' RouterLink={Link} to='/'>
        <Icon InlineIcon={IconArrowLeft} />
        Cancel
      </Button>
      <Button
        size='md'
        extraClasses={styles.button}
        appearance='primary'
        type='submit'
        disabled={!canConfirm}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.preventDefault();
          onConfirm();
        }}
      >
        Confirm
      </Button>
    </div>
  );
};

export default UploadCSVSubmit;
